<!-- Page banner Area -->
<div class="page-banner bg-3">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-content">
                    <h2>Terms Condition</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Terms Condition</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page banner Area -->

<!-- Terms ConditionArea -->
<div class="container-fluid mt-5 mb-5">
    <div class="">
        <div class="privacy-policy-text">
            <h2>Acceptance of Terms</h2>
            <p>Welcome to Lemonmode. By accessing our website, creating an account, or using our shipping and logistics services, you agree to be bound by these Terms and Conditions. Please read these terms carefully before using our platform. If you do not agree with any part of these terms, you should not use our services or access our website.</p>
            <p>These terms constitute a legally binding agreement between you and Lemonmode regarding your use of our logistics platform, including air freight, ocean freight, trucking, warehousing, and related services. We reserve the right to modify these terms at any time, and your continued use of our services following any changes constitutes acceptance of the updated terms.</p>
            <h2>Service Description and Scope</h2>
            <p>Lemonmode provides comprehensive logistics solutions including domestic and international shipping, air and ocean freight forwarding, customs brokerage, warehousing, distribution, and supply chain management services. We operate across 120+ countries with a network of trusted carrier partners and logistics facilities.</p>
            <p>Our services are subject to availability and may vary based on destination, shipment type, weight, dimensions, and applicable regulations. We strive to provide accurate delivery estimates, but actual transit times may be affected by factors beyond our control including weather conditions, customs processing, and carrier operational issues.</p>
            <h2>User Responsibilities and Prohibited Items</h2>
            <p>As a user of our services, you are responsible for providing accurate and complete information about your shipments, including proper descriptions, values, and documentation required for customs clearance. You must ensure that all shipments comply with applicable laws and regulations of origin, transit, and destination countries.</p>
            <p>You agree not to ship prohibited or restricted items including hazardous materials, illegal goods, weapons, perishable items without proper packaging, counterfeit products, and any items restricted by international shipping regulations. You are liable for any consequences arising from shipping prohibited items or providing false information about your shipments.</p>
            <h2>Liability and Limitations</h2>
            <p>Lemonmode strives to handle all shipments with utmost care and professionalism. However, our liability for lost, damaged, or delayed shipments is limited to the terms specified in our service agreements and applicable international shipping conventions. We strongly recommend purchasing shipping insurance for high-value items.</p>
            <p>We are not liable for delays or failures caused by circumstances beyond our reasonable control, including natural disasters, government actions, customs delays, incorrect addresses provided by customers, or carrier operational issues. Our total liability shall not exceed the actual shipping charges paid for the affected shipment unless additional insurance coverage was purchased.</p>
        </div>
    </div>
</div>
<!-- End Terms Condition Area -->

<!-- Newsletter Area -->
<div class="newsletter-area">
    <div class="container">
        <div class="newsletter-content">
            <div class="row align-items-center">
                <!-- <div class="col-lg-5 col-md-12">
                    <div class="newsletter-title">
                        <h3>Subscribe to our newsletter:</h3>
                        <p>Focused on the transport and logistic industry</p>
                    </div>
                </div>

                <div class="col-lg-7 col-md-12">
                    <form class="newsletter-form">
                        <input type="email" class="form-control" placeholder="Enter your email" name="EMAIL" required="" autocomplete="off">
                        <button type="submit" class="btn btn-primary">Subscribe</button>
                    </form>
                </div> -->
            </div>
        </div>
    </div>
</div>
<!-- End Newsletter Area -->
